// ✅ components/OrdersTable.jsx
import React from "react";
import moment from "moment";

const formatDateTime = (iso) => moment(iso).format("YYYY-MM-DD hh:mm:ss A");



const OrdersTable = ({ orders, isOrderSelected, toggleOrderSelection, pushToZippie }) => {
  return (
    <table className="table table-striped table-bordered">
      <thead className="thead-dark">
        <tr>
          <th>Select</th>
          <th>Date and Time</th>
          <th>Order ID</th>
          <th>Delivery Status</th>
          <th>Tags</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {orders.map((order) => (
          <tr key={order._id}>
            <td>
              <input
                type="checkbox"
                checked={isOrderSelected(order.id)}
                onChange={() => toggleOrderSelection(order.id)}
                disabled={order.cancelled_at !== null}
              />
            </td>
            <td>{formatDateTime(order.created_at)}</td>
            <td>{order.orderId}</td>
            <td>{order.fulfillments?.[0]?.shipment_status
              ? order.fulfillments[0].shipment_status
                  .split('_')
                  .map(w => w.charAt(0).toUpperCase() + w.slice(1))
                  .join(' ')
              : "Pending"}</td>
            <td>{order.tags.join(", ")}</td>
            <td>{order.cancelled_at ? "Order Cancelled" : order.zippee || "Pending"}</td>
            <td>
              <button
                className="btn btn-primary btn-sm"
                onClick={() => pushToZippie(order.id)}
                disabled={order.cancelled_at !== null}
              >Push to Zippee</button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default OrdersTable;
